import { io as ClientIO } from 'socket.io-client';

// Prefer environment; fallback to local. Matches .env toggles.
const configuredApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || configuredApiUrl.replace(/\/api\/?$/i, '');

class SocketService {
  static instance;
  socket = null;

  static getInstance() {
    if (!SocketService.instance) {
      SocketService.instance = new SocketService();
    }
    return SocketService.instance;
  }

  connect(userId = 'superadmin') {
    if (this.socket) return this.socket;
    this.socket = ClientIO(SOCKET_URL, {
      transports: ['websocket'],
    });
    this.socket.on('connect', () => {
      try {
        this.socket.emit('join', { userId, userType: 'superadmin' });
        // console.log('[socket] connected as superadmin', this.socket.id);
      } catch {}
    });
    this.socket.on('disconnect', () => {
      // console.log('[socket] disconnected');
    });
    return this.socket;
  }

  // Generic on/off
  on(event, handler) {
    this.socket?.on(event, handler);
  }
  off(event, handler) {
    if (!this.socket) return;
    if (handler) this.socket.off(event, handler);
    else this.socket.off(event);
  }

  // Convenience bindings
  onBookingCreated(handler) { this.on('bookingCreated', handler); }
  offBookingCreated(handler) { this.off('bookingCreated', handler); }
  onBookingUpdated(handler) { this.on('bookingUpdated', handler); }
  offBookingUpdated(handler) { this.off('bookingUpdated', handler); }
  onBookingDeleted(handler) { this.on('bookingDeleted', handler); }
  offBookingDeleted(handler) { this.off('bookingDeleted', handler); }

  onShopCreated(handler) { this.on('shopCreated', handler); }
  offShopCreated(handler) { this.off('shopCreated', handler); }
  onShopUpdated(handler) { this.on('shopUpdated', handler); }
  offShopUpdated(handler) { this.off('shopUpdated', handler); }
  onShopDeleted(handler) { this.on('shopDeleted', handler); }
  offShopDeleted(handler) { this.off('shopDeleted', handler); }

  // New notification events
  onNewNotification(handler) { this.on('newNotification', handler); }
  offNewNotification(handler) { this.off('newNotification', handler); }
  onNotificationUpdate(handler) { this.on('notificationUpdate', handler); }
  offNotificationUpdate(handler) { this.off('notificationUpdate', handler); }

  // User presence events
  onUserOnline(handler) { this.on('userOnline', handler); }
  offUserOnline(handler) { this.off('userOnline', handler); }
  onUserOffline(handler) { this.on('userOffline', handler); }
  offUserOffline(handler) { this.off('userOffline', handler); }

  // Message events for activity monitoring
  onReceiveMessage(handler) { this.on('receiveMessage', handler); }
  offReceiveMessage(handler) { this.off('receiveMessage', handler); }

  // Customer/User registration events
  onCustomerRegistered(handler) { this.on('customerRegistered', handler); }
  offCustomerRegistered(handler) { this.off('customerRegistered', handler); }
  onStaffRegistered(handler) { this.on('staffRegistered', handler); }
  offStaffRegistered(handler) { this.off('staffRegistered', handler); }

  // System events
  onSystemStatusChange(handler) { this.on('systemStatusChange', handler); }
  offSystemStatusChange(handler) { this.off('systemStatusChange', handler); }

  // Connection status
  isConnected() {
    return this.socket?.connected || false;
  }

  // Get connection status
  getConnectionStatus() {
    return {
      connected: this.socket?.connected || false,
      id: this.socket?.id || null,
      lastConnected: this.socket ? new Date().toISOString() : null
    };
  }
}

export default SocketService.getInstance();
